import React from 'react'
import EyefinitySectionFields from '../EyefinitySectionFields'

export default function Patient(props) {
  return <EyefinitySectionFields {...props} sectionName="patient" title="Patient" />
}
